import { useContext, useState } from 'react'
import { X } from '@phosphor-icons/react'
import { DateTime } from 'luxon'

import { SL_Button } from '../../../components/buttons/Button'
import { FiltersModal } from './FiltersModal'

import { colors } from '../../../services/style'
import { displayMessage } from '../../../helpers/messages'
import { GeneralContext } from '../../../context/GeneralContext/GeneralContext'

import exportToExcel from '../../../services/export'

export const ModalTitle = ({ onCloseButtonClick, title, data, columns, extraContent = null, filters, onFilter, central_id }) => {
    const { mobile_mode, windowWidth } = useContext(GeneralContext)

    const [openFilters, setOpenFilters] = useState(false)
    const [showCleanFiltersButton, setShowCleanFiltersButton] = useState(false)

    const onExportClick = () => {
        const now = DateTime.now().toFormat('dd/MM/yyyy')
        const reportTitle = `${title}-${now}.xlsx`
        const columnsToExport = columns.filter((col) => !col.noExport)
        const reportData = data.map((action) => {
            const object = {}
            columnsToExport.forEach((col) => {
                object[col.title] = action[col.dataIndex]
            })

            return object
        })
        exportToExcel(reportData, reportTitle)
    }

    const onClickFilter = (obj, central) => {
        onFilter(obj, central)
        setShowCleanFiltersButton(true)
    }

    const onClickCleanFilters = () => {
        onFilter(null, central_id, true)
        setShowCleanFiltersButton(false)
    }

    return (
        <div style={{ borderBottom: `1px solid ${colors['sl-gray'][100]}` }} className={`w-full report-table-title-div flex text-white flex-wrap justify-between items-center`}>
            {openFilters && <FiltersModal onClose={() => setOpenFilters(false)} filters={filters} onFilter={onClickFilter} central_id={central_id} />}
            <div className="flex gap-3">
                <X size={'2.22vh'} color={colors['sl-gray'][50]} className="cursor-pointer" onClick={onCloseButtonClick} />
                <h3 className="text-medium report-table-title">{title}</h3>
            </div>
            {!!extraContent ? extraContent : (
                <div className='flex gap-2'>
                    {filters?.length ? <>
                        {showCleanFiltersButton && <SL_Button className="bg-white/10 hover:bg-white/20 report-table-title-button rounded-[8px] px-4" onClick={onClickCleanFilters}>
                            {displayMessage('CLEAN_FILTERS')}
                        </SL_Button>}
                        <SL_Button className="bg-white/10 hover:bg-white/20 report-table-title-button rounded-[8px] px-4" onClick={() => setOpenFilters(true)}>
                            {displayMessage('FILTERS')}
                        </SL_Button>
                    </> : null}
                    <SL_Button className="bg-white/10 hover:bg-white/20 report-table-title-button rounded-[8px] px-4" onClick={() => onExportClick()}>
                        {displayMessage('CSV_EXPORT')}
                    </SL_Button>
                </div>)}

        </div>
    )
}
